/**
 * SPDX-License-Identifier: MPL-2.0
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2023-2024 (c) Daniel Littfinski, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import React, { useState } from 'react';
import { CompanyDataActions } from './CompanyDataActions';
import MsgListActions, { BootstrapColor_t } from 'MsgList/MsgListActions';
import { Dispatch } from '@reduxjs/toolkit';
import { connect } from 'react-redux';
import { Company } from 'Api/generated';

const initialState: Company = {
  Id: '',
  Name: '',
  ShortName: '',
  Users: [],
  OpcUaClients: [],
};

interface IAddCompanyProps {
  companies: Company[];
}

type DispatchProps_t = ReturnType<typeof mapDispatchToProps>;

export function AddCompany({ companies: companies, AddMsg, AddNewCompany }: IAddCompanyProps & DispatchProps_t) {
  const companyNames = companies.map((el) => el.Name);
  const companyShortNames = companies.map((el) => el.ShortName);

  const [addNewCompany, setaddNewCompany] = useState<Company>(initialState);

  // Value for rerendering
  const [companyName, setCompanyName] = useState<string>('');
  const [companyShortName, setCompanyShortName] = useState<string>('');

  // Check and add Companyname
  const handleCompanyName = (event: React.ChangeEvent<HTMLInputElement>) => {
    const _addCompanyName = { ...addNewCompany } as any;
    _addCompanyName[event.target.name] = event.target.value;
    setaddNewCompany(_addCompanyName);
  };

  //Save new created companydata
  const SaveCompanyData = async () => {
    AddNewCompany(addNewCompany);
    AddMsg('Created new Company in DB.', 'success ');
    setCompanyName('');
    setCompanyShortName('');
    addNewCompany.Name = '';
    addNewCompany.ShortName = '';
  };

  const onSubmitForm = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    SaveCompanyData();
    return false;
  };

  return (
    <form onSubmit={onSubmitForm}>
      <div className="card">
        <div className="card-body">
          <div className="row">
            <div className="form-group col-md-4">
              <label>Company name</label>
              <input
                className="form-control"
                name="Name"
                placeholder={'Company name'}
                value={companyName}
                onChange={(e) => (handleCompanyName(e), setCompanyName(e.target.value))}
                type="text"
              />
            </div>
            <div className="form-group col-md-4 ">
              <label>Company Shortname</label>
              <input
                className="form-control"
                name="ShortName"
                placeholder="Shortname"
                value={companyShortName}
                onChange={(e) => (handleCompanyName(e), setCompanyShortName(e.target.value))}
                type="text"
              />
            </div>
          </div>
          <div>
            <input
              type="submit"
              className={
                !(
                  (companyNames.includes(addNewCompany.Name) && addNewCompany.Name != '') ||
                  (companyShortNames.includes(addNewCompany.ShortName) && addNewCompany.ShortName != '')
                )
                  ? 'btn btn-primary'
                  : 'btn btn-danger'
              }
              disabled={
                companyNames.includes(addNewCompany.Name) ||
                companyShortNames.includes(addNewCompany.ShortName) ||
                addNewCompany.Name == '' ||
                addNewCompany.ShortName == ''
              }
              value={
                !(
                  (companyNames.includes(addNewCompany.Name) && addNewCompany.Name != '') ||
                  (companyShortNames.includes(addNewCompany.ShortName) && addNewCompany.ShortName != '')
                )
                  ? 'Create new company'
                  : 'Companyname already exists!'
              }
            />
          </div>
        </div>
      </div>
    </form>
  );
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    AddMsg: (msg: string, severity: BootstrapColor_t) => MsgListActions.Add(msg, severity)(dispatch),
    AddNewCompany: (newCompany: Company) => CompanyDataActions.CreateCompany(newCompany)(dispatch),
  };
};

export default connect(undefined, mapDispatchToProps)(AddCompany);
